import { Component, input } from '@angular/core';
import { ProgressSpinner } from 'primeng/progressspinner';

//component that containerizes the blue spinner used in various places in the application
@Component({
	selector: 'app-embark-spinner',
	imports: [ProgressSpinner],
	templateUrl: './embark-spinner.component.html',
	styleUrl: './embark-spinner.component.sass',
})
export class EmbarkSpinnerComponent {
	public readonly strokeWidth = input.required<string>(); // stroke width of the spinner itself
	public readonly size = input.required<string>(); //width and height that the spinner box will be

	public get spinnerClass(): string {
		return `w-${this.size()}rem h-${this.size()}rem text-blue-spinner`;
	}
}
